import moment from 'moment';
export class LegacyConnectHealthDataRequestToLegacyConnectHealthDataRequestDtoConverter {
    static create = () => {
        return new LegacyConnectHealthDataRequestToLegacyConnectHealthDataRequestDtoConverter();
    };
    toModel = (source) => {
        return {
            dosDay: moment(source.dateOfService).date(),
            dosMonth: moment(source.dateOfService).month() + 1,
            dosYear: moment(source.dateOfService).year(),
            address1: source.address1,
            address2: source.address2,
            city: source.city,
            state: source.state,
            zipCode: source.zip,
            ssnLastFour: source.ssnLastFour,
            phoneType: source.phoneType,
            phoneNumber: source.phoneNumber,
            gender: source.gender
        };
    };
}
